import React, { FC } from 'react';
import { connect } from 'react-redux';

import { ReduxState } from 'app/redux/types';

import { SubmissionState } from '../../../constants';
import { selectBigStakes, selectStakesWithDecisionSize } from '../../../selectors/bigStakes';
import { BigStakes } from '../../../types/bigStakes';
import Entry from './Entry';

import styles from './BigStakesBarEntries.module.scss';

// ---

type StoreProps = {
  bigStakes: BigStakes;
  stakesWithDecisionSize: number;
};

const BigStakesEntries: FC<StoreProps> = ({
  bigStakes,
  stakesWithDecisionSize,
}) => {
  const stakes: JSX.Element[] = [];

  const stakesComplete = (bigStakes.size - stakesWithDecisionSize) === 0;

  for (const [, stake] of bigStakes) {
    // Отображаем только ставки с ошибками
    if (stakesComplete && stake.submission === SubmissionState.ACCEPTED) {
      continue;
    }

    stakes.push(
      <Entry key={stake.dialogId}
             dialogId={stake.dialogId} />,
    );
  }

  return (
    <div className={styles.container}
         data-test="bigStakesEntries-container">
      {stakes}
    </div>
  );
};

const mapStateToProps = (state: ReduxState): StoreProps => ({
  bigStakes: selectBigStakes(state),
  stakesWithDecisionSize: selectStakesWithDecisionSize(state),
});

export default connect(mapStateToProps)(BigStakesEntries);
